export const getters = {
  getCounter(state) {
    return state.counter;
  },
};
